import { Component } from "react";
import { connect } from "react-redux";
import Swal from 'sweetalert2';
import {
  hideAlertAction
} from "appRedux/actions/Common";

import {
  MESSAGE_SUCCESS,
} from "constants/ActionTypes";

import { injectIntl } from 'react-intl';
import Parser from 'html-react-parser';

export class AlertMessage extends Component {

  constructor() {
    super();
    this.state = {
    };
  }

  componentDidUpdate() {
    var intl = this.props.intl;
    if (this.props.showAlert && this.props.alertMessage) {
      if (this.props.alertMessageStatus === MESSAGE_SUCCESS) {

        Swal.fire({
          title: Parser(intl.formatMessage({ id: this.props.alertMessage })),
          icon: "success"
        });
        // To clean message props
        this.props.hideAlertAction();

      } else {

        Swal.fire({
          title: Parser(intl.formatMessage({ id: this.props.alertMessage })),
          icon: "warning"
        });
        // To clean message props
        this.props.hideAlertAction();

      }
    }
  }

  render() {
    return (null);
  }
}

const mapStateToProps = ({ common }) => {
  const {
    alertMessage,
    showAlert,
    alertMessageStatus,

  } = common;

  return {
    alertMessage,
    showAlert,
    alertMessageStatus,
  }
};

export default injectIntl(
  connect(
    mapStateToProps,
    { hideAlertAction })(AlertMessage)
);

